import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Radium from 'higher-order-components/configured-radium/'

class IconLink extends Component {
  static propTypes = {
    href: PropTypes.string,
    icon: PropTypes.string,
    label: PropTypes.string
  }
  /**
   * @param {String} label - Label Value.
   * @param {Url} href - Url Value.
   * @param {Url} icon - Icon Url.
   * @returns {ReactElement} React Component
   */
  render() {
    return (
      <span style={styles.base}>
        <a style={styles.a} href={this.props.href}>
          <img style={styles.icon} alt={this.props.label} src={this.props.icon} />
          {this.props.label}
        </a>
      </span>
    )
  }
}

const styles = {
  base: {
    display: 'inline-block',
    lineHeight: '1.5em',
    textTransform: 'uppercase',
    opacity: 0.75,
    ':hover': {
      opacity: 1
    }
  },
  a: {
    display: 'inline-block',
    textDecoration: 'none',
    color: 'currentColor',
    fontWeight: 'bold',
    letterSpacing: '2px'
  },
  icon: {
    width: '1.5em',
    height: '1.5em',
    display: 'inline-block',
    position: 'relative',
    top: '.35em',
    left: '0em',
    paddingRight: '.5em'
  }
}

export default Radium(IconLink)



// WEBPACK FOOTER //
// ./src/containers/icon-link/index.jsx